import { Button } from "@mui/material";
import React from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const FONT = "'Plus Jakarta Sans', system-ui, -apple-system, sans-serif";

const ButtonBack = ({fullWidth, handleBack}) => {
  return (
    <div style={{ width: fullWidth ? "100%" : "auto" }}>
        <Button
          className="btn-outlined"
          onClick={handleBack}
          sx={{
            mr: fullWidth ? 0 : 2,
            width: fullWidth ? "100%" : "auto",
            height: fullWidth ? 44 : 40,
            px: 2,
            gap: 0.75,
            borderRadius: "10px !important",
            background: "#FFFFFF !important",
            color: "#0F1B2A !important",
            border: "1px solid #D5DEE7 !important",
            fontFamily: FONT,
            fontSize: 14,
            fontWeight: 600,
            textTransform: "none !important",
            letterSpacing: 0,
            boxShadow: "none",
            "&:hover": { background: "#F4F7FA !important", borderColor: "#B4C6DA !important" },
          }}
        >
            <ArrowBackIcon sx={{ fontSize: 17 }} /> Back
        </Button>
    </div>
  );
};

export default ButtonBack;
